import _styled from "styled-components";
import Box from "../../../../Styled/Box";
import logo from "../../../../../wwwroot/images/terria-watermark.svg";
import { jsx as _jsx } from "react/jsx-runtime";
export const TerriaLogo = () => {
  return /*#__PURE__*/_jsx(Box, {
    as: "a",
    target: "_blank",
    rel: "noopener noreferrer",
    href: "https://terria.io/",
    children: /*#__PURE__*/_jsx(_StyledImg, {
      src: logo,
      title: "Built with Terria"
    })
  });
};
var _StyledImg = _styled("img").withConfig({
  displayName: "TerriaLogo___StyledImg",
  componentId: "sc-bk2yek-0"
})({
  height: "24px"
});